import React, { memo } from "react";
import ImagesConfig from "components/ImagesConfig";
import FieldBody from "pages/OrderHistoryPage/Components/FieldBody";
import useStyles from "./styles";
import theme from "theme";
import clsx from "clsx";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { formatCash } from "config/constant";
import { STATUS_MERCHANDISING_ORDER } from "config/constant";

const relaceText = text => {
	if (text?.includes("HOP")) {
		return text.replace("HOP", "hộp");
	}
	return text;
};

const BodyLoyaltyOrder = memo(({ product, products }) => {
	const classes = useStyles();

	return (
		<Grid classes={{ root: classes.rootBody }}>
			{products?.map((product, index) => (
				<Grid
					classes={{
						root: clsx(
							classes.rootProduct,
							index < products?.length - 1 && classes.border
						)
					}}
					key={index}
				>
					<Grid classes={{ root: classes.rootImage }}>
						<ImagesConfig
							image={product?.image}
							imageDefault={Images.icProductDefault}
							width={70}
							height={70}
						/>
					</Grid>
					<Grid classes={{ root: classes.rootInfo }}>
						<Grid classes={{ root: classes.name }}>
							{product?.name || ""}
						</Grid>
						<FieldBody
							title="Số lượng"
							value={relaceText(product?.totalQuantity || "-")}
						/>
						<FieldBody
							title="Số điểm đã dùng"
							value={formatCash(product?.point || 0)}
							color={theme.palette.error.light}
						/>
					</Grid>
				</Grid>
			))}
			<Grid container spacing={2} classes={{ root: classes.totalPrice }}>
				<Grid item xs={6} classes={{ root: classes.subText }}>
					Trạng thái
				</Grid>
				<Grid
					item
					xs={6}
					classes={{ root: classes.status }}
					style={{
						color: STATUS_MERCHANDISING_ORDER[product?.status]
							?.color
					}}
				>
					{STATUS_MERCHANDISING_ORDER[product?.status]?.statusName}
				</Grid>
			</Grid>
		</Grid>
	);
});

export default BodyLoyaltyOrder;
